import { render } from "./settings.vue?vue&type=template&id=79ed9fd5&scoped=true"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./settings.vue?vue&type=style&index=1&id=79ed9fd5&lang=scss&scoped=true"

import exportComponent from "D:\\Build Apps\\Natan\\jlm_manager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ed9fd5"]])

export default __exports__